import React, { memo } from "react";
import { View, Modal, TouchableOpacity, StyleSheet } from "react-native";
import color from "@constants/color";
import { width } from "@constants/metrics";
import Text from "@components/CustomText";
import t from "@constants/localization";

interface Props {
  onPress?: () => void;
  visible?: boolean;
  onPressCancel?: () => void;
}
const PATH = "screens/Wallet/v2/Components/CancelDisputeModal";

const CancelDisputeModal = (props: Props) => {
  const {
    onPress = () => {},
    visible = true,
    onPressCancel = () => {},
  } = props;

  return (
    <Modal visible={visible} transparent={true}>
      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>
          <Text variant="subtitle_20" style={styles.headingText}>
            {t(`${PATH}/cancelDispute`)}
          </Text>
          <Text variant="body_text_3" style={styles.subHeadingText}>
            {t(`${PATH}/cancelDisputeDesc`)}
          </Text>
          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.primaryButton]}
              onPress={onPress}
            >
              <Text variant="title_18_semi" style={styles.whiteButtonText}>
                {t(`${PATH}/yes`)}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.button, styles.whiteButton]}
              onPress={onPressCancel}
            >
              <Text variant="title_18_semi" style={styles.primaryButtonText}>
                {t(`${PATH}/no`)}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: color.modalBackground,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    width: width - 64,
    backgroundColor: color.white,
    height: 187,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 24,
  },
  headingText: {
    color: color.Gray20,
    paddingVertical: 5,
  },
  subHeadingText: {
    color: color.mediumBlacklightBlack,
    textAlign: "center",
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
  },
  button: {
    marginVertical: 12,
    marginHorizontal: 8,
    paddingVertical: 8,
    borderWidth: 1,
    borderRadius: 20,
    flex: 1,
    alignItems: "center",
  },
  primaryButton: {
    borderColor: color.primary,
    backgroundColor: color.primary,
  },
  whiteButton: {
    borderColor: color.primary,
    backgroundColor: color.white,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "500",
    lineHeight: 22,
  },
  primaryButtonText: {
    color: color.primary,
  },
  whiteButtonText: {
    color: color.white,
  },
});

export default memo(CancelDisputeModal);
